import packageJson from "../../package.json";

declare const __BUILD_TIMESTAMP__: string;

export interface VersionInfo {
  version: string;
  buildDateTime: string;
  environment: string;
}

export const getVersionInfo = (): VersionInfo => {
  const buildTime =
    typeof __BUILD_TIMESTAMP__ !== "undefined"
      ? new Date(__BUILD_TIMESTAMP__).toLocaleString()
      : new Date().toLocaleString();
  return {
    version: packageJson.version,
    buildDateTime: buildTime,
    environment: import.meta.env.MODE || "development",
  };
};

export const getDisplayVersion = (): string => {
  const { version, environment } = getVersionInfo();
  if (environment === "development") {
    return `v${version}-dev`;
  }
  return `v${version}`;
};

export const getFullVersionString = (): string => {
  const { version, buildDateTime, environment } = getVersionInfo();
  return `v${version} (${environment}) - Built: ${buildDateTime}`;
};
